import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStethoscope = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 4h-1a2 2 0 0 0 -2 2v3.5a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 15a6 6 0 1 0 12 0v-3" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 3v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 3v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 10a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" })
	]
});
export { SvgStethoscope as ReactComponent };
